var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.12 0 0 0.12 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2088.6,2767.1H827.1c-21.5,0-38.9-17.4-38.9-38.9V271.8c0-21.5,17.4-38.9,38.9-38.9h1261.5     c21.5,0,38.9,17.4,38.9,38.9v2456.3C2127.5,2749.7,2110.1,2767.1,2088.6,2767.1z",
    fill: "#6a483a",
    className: "svgShape color3a556a-0 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 1189,
    height: 2044.2,
    x: 863.4,
    y: 463.6,
    fill: "#ffffff",
    className: "svgShape colorffffff-1 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1587.6,368.5h-259.4c-11.1,0-20.1-9-20.1-20.1l0,0c0-11.1,9-20.1,20.1-20.1h259.4c11.1,0,20.1,9,20.1,20.1     l0,0C1607.6,359.6,1598.7,368.5,1587.6,368.5z",
    fill: "#ffffff",
    className: "svgShape colorffffff-2 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 1457.9,
    cy: 2632.2,
    r: 92.3,
    fill: "#ffffff",
    className: "svgShape colorffffff-3 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 1106.1,
    height: 907.4,
    x: 904.9,
    y: 512.5,
    fill: "#f4f4f4",
    className: "svgShape colorf4f4f4-4 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 877.8,
    height: 16.2,
    x: 1133.1,
    y: 1514.4,
    fill: "#efefef",
    className: "svgShape colorefefef-5 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 627.1,
    height: 16.2,
    x: 1133.1,
    y: 1601.9,
    fill: "#efefef",
    className: "svgShape colorefefef-6 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 175.5,
    height: 175.5,
    x: 904.9,
    y: 1478.5,
    fill: "#efefef",
    className: "svgShape colorefefef-7 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1025.2,1523.6c-20.2-28.3-65.9-18.3-71.9,17.7c-0.1,0.8-0.3,1.6-0.4,2.4c-0.8,4.3-0.3,9.1,1,14.3      c0.9,3.5,2.3,6.9,4.1,10l32.9,56.4c0.7,1.2,2.5,1.3,3.3,0l32.3-53.1c3.7-6,5.8-12.8,6.2-19.8v-0.7      C1033.3,1541.1,1030.8,1531.5,1025.2,1523.6z",
    fill: "#ff763b",
    className: "svgShape colorff3b57-8 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 992.4,
    cy: 1546.1,
    r: 19.9,
    fill: "#fffdfc",
    className: "svgShape colorfcffff-9 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1776.2,927.5c0,3.4-0.1,6.8-0.3,10.2c-2.6,66.5-26.2,130.4-66.7,182.6c-19.9,25.6-43.8,48.4-71.3,67.2     c-3,2.1-6,4-9,5.9c-17.8,11.3-36.9,21-57.3,28.8c-78.8,30.2-162.2,26.9-234.6-2.9c-0.8-0.3-1.5-0.6-2.2-0.9     c-37.2-15.5-71.3-38.1-100.4-66.7c-31.5-31.1-57-69.1-73.9-113.1c-62.8-164.2,19.4-348.2,183.5-411     c164.2-62.8,348.2,19.3,411,183.5C1769.8,849.5,1776.6,888.8,1776.2,927.5z",
    fill: "#ffffff",
    className: "svgShape colorffffff-10 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1545.3,679.7c-80.4-92.6-238.3-5.1-240.7,148.2c-0.1,4.3-0.1,8.7-0.4,13c-0.5,6.3-1.1,12.5-1.9,18.6       c-4.8,36-18.5,70.1-38.2,100.6c-49.8,77.2-11.3,143.8,59.6,174.7l275.6-58.7c62.2-21.6,104-52.2,37.7-130.7       c-12.6-14.9-23.8-30.8-32.5-48.3c-18.1-36.5-24.7-73.4-18.8-110.8C1630.4,756.8,1617.6,698.8,1545.3,679.7z",
    fill: "#2b221e",
    className: "svgShape color2b231e-11 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1637.9,1187.4c-3,2.1-6,4-9,5.9c-17.8,11.3-36.9,21-57.3,28.8c-78.8,30.2-162.2,26.9-234.6-2.9       c-0.3-1.5-0.6-3-0.8-4.5c-4-20.1-9-41.1-14.7-63.8l5.1-16.7l48.9-160.4c21.2-2.2,37.9-3.8,53.7-4.9c24.3-1.8,46.4-2.4,79.9-1.9       c9.6,0.1,20.1,0.3,31.9,0.6c11.9,0.3,23.8,1.7,35.3,4.8c11.8,3.1,23.5,7.8,34.8,15c0.4,0.2,0.7,0.4,1.1,0.6       c4.3,2.7,8.5,5.8,12.7,9.2c1,0.8,2.1,1.7,3.1,2.7l10.1,39c0.6,6.2,1.2,12.6,1.5,19.3       C1642.1,1095.7,1641.4,1141.2,1637.9,1187.4z",
    fill: "#ff4d00",
    className: "svgShape colorff9900-12 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1430.5,984.6c-0.5-2.1-0.9-4.3-1.1-6.6C1429.7,980.2,1430.1,982.4,1430.5,984.6z",
    fill: "#feab88",
    className: "svgShape colorfebd88-13 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1522.1,729.4c9.8,29.4,23.1,47.6,38.5,59.2c3.3,199.8-139.5,167.4-184.3,90.4         c-22.5,1.1-43.9-14.4-46.9-39.7c-0.6-5,0.7-10.3,4.4-13.9c14.6-14.4,37,21.7,37,21.7l2.5-47.2         C1441.4,789.3,1497.2,770.1,1522.1,729.4z",
    fill: "#faab89",
    className: "svgShape colorfab589-14 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1558.9 810.8c37.6 8.2 19.1 56.5-9.8 60.7L1558.9 810.8zM1509.1 917.9v56.7c0 1.1-.1 2.3-.2 3.4-1.7 20.5-18.8 36.6-39.8 36.6-18.6 0-34.2-12.7-38.7-29.9l0 0c-.3-2.2-.7-4.4-1.1-6.6 0 0 0 0 0-.1-.1-1.1-.2-2.2-.2-3.3V918h80V917.9z",
    fill: "#faab89",
    className: "svgShape colorfab589-15 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1709.2 1120.2c-19.9 25.6-43.8 48.4-71.3 67.2-3 2.1-6 4-9 5.9-5.1-7.9-9.9-16.5-14.1-25.7l-3.1-96.1-2.8-85.3c.7.4 1.5.8 2.2 1.2.4.2.7.4 1.1.6 4.2 2.5 8.5 5.5 12.7 9.2 1 .8 2.1 1.7 3.1 2.7 11 9.8 22.2 23 33.8 39.5C1677.1 1061 1692.7 1088.1 1709.2 1120.2zM1375.5 973.8l-4.4 151-.8 27.1c-14.2 19.6-25.2 39.6-34.1 62.8-.5 1.2-1 2.4-1.3 3.6-37.2-15.5-71.3-38.1-100.4-66.7 6.1-25 13.7-48.6 23-69.9C1282.1 1025.9 1319.3 985.5 1375.5 973.8z",
    fill: "#ff4d00",
    className: "svgShape colorff9900-16 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 877.8,
    height: 16.2,
    x: 1133.1,
    y: 1748.5,
    fill: "#efefef",
    className: "svgShape colorefefef-17 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 627.1,
    height: 16.2,
    x: 1133.1,
    y: 1836,
    fill: "#efefef",
    className: "svgShape colorefefef-18 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 175.5,
    height: 175.5,
    x: 904.9,
    y: 1712.7,
    fill: "#efefef",
    className: "svgShape colorefefef-19 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 992.6,
    cy: 1800.4,
    r: 66.1,
    fill: "#ed8153",
    className: "svgShape color53b4ed-20 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 992.6,
    cy: 1800.4,
    r: 56.1,
    fill: "#ffffff",
    className: "svgShape colorffffff-21 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M992.6 1758.6c-.6 0-1.1-.5-1.1-1.1v-8c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1v8C993.7 1758.1 993.2 1758.6 992.6 1758.6zM971.1 1764.3c-.4 0-.7-.2-1-.5l-4-6.9c-.3-.5-.1-1.2.4-1.5s1.2-.1 1.5.4l4 6.9c.3.5.1 1.2-.4 1.5C971.5 1764.3 971.3 1764.3 971.1 1764.3zM955.4 1780.1c-.2 0-.4 0-.5-.1l-6.9-4c-.5-.3-.7-1-.4-1.5s1-.7 1.5-.4l6.9 4c.5.3.7 1 .4 1.5C956.1 1779.9 955.7 1780.1 955.4 1780.1zM949.6 1801.6h-8c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h8c.6 0 1.1.5 1.1 1.1C950.7 1801.1 950.2 1801.6 949.6 1801.6zM948.4 1827.1c-.4 0-.7-.2-1-.5-.3-.5-.1-1.2.4-1.5l6.9-4c.5-.3 1.2-.1 1.5.4s.1 1.2-.4 1.5l-6.9 4C948.8 1827 948.6 1827.1 948.4 1827.1zM967.1 1845.7c-.2 0-.4 0-.5-.1-.5-.3-.7-1-.4-1.5l4-6.9c.3-.5 1-.7 1.5-.4s.7 1 .4 1.5l-4 6.9C967.8 1845.5 967.5 1845.7 967.1 1845.7zM992.6 1852.6c-.6 0-1.1-.5-1.1-1.1v-8c0-.6.5-1.1 1.1-1.1s1.1.5 1.1 1.1v8C993.7 1852.1 993.2 1852.6 992.6 1852.6zM1018.1 1845.7c-.4 0-.7-.2-1-.5l-4-6.9c-.3-.5-.1-1.2.4-1.5s1.2-.1 1.5.4l4 6.9c.3.5.1 1.2-.4 1.5C1018.4 1845.7 1018.2 1845.7 1018.1 1845.7zM1036.7 1827.1c-.2 0-.4 0-.5-.1l-6.9-4c-.5-.3-.7-1-.4-1.5s1-.7 1.5-.4l6.9 4c.5.3.7 1 .4 1.5C1037.5 1826.9 1037.1 1827.1 1036.7 1827.1zM1043.6 1801.6h-8c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h8c.6 0 1.1.5 1.1 1.1C1044.6 1801.1 1044.2 1801.6 1043.6 1801.6zM1029.8 1780.1c-.4 0-.7-.2-1-.5-.3-.5-.1-1.2.4-1.5l6.9-4c.5-.3 1.2-.1 1.5.4s.1 1.2-.4 1.5l-6.9 4C1030.2 1780.1 1030 1780.1 1029.8 1780.1zM1014.1 1764.4c-.2 0-.4 0-.5-.1-.5-.3-.7-1-.4-1.5l4-6.9c.3-.5 1-.7 1.5-.4.5.3.7 1 .4 1.5l-4 6.9C1014.8 1764.2 1014.5 1764.4 1014.1 1764.4z",
    fill: "#ed8153",
    className: "svgShape color53b4ed-22 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "994 1797.5 992.6 1763.9 991.2 1797.5",
    fill: "#ed8153",
    className: "svgShape color53b4ed-23 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "988.8 1795.4 1023.7 1825.4 986.8 1798",
    fill: "#ff763b",
    className: "svgShape colorff3b57-24 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "990.6 1803 970.4 1814.2 989.8 1800.8",
    fill: "#ed8153",
    className: "svgShape color53b4ed-25 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 992.6,
    cy: 1800.4,
    r: 5,
    fill: "#ed8153",
    className: "svgShape color53b4ed-26 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 992.6,
    cy: 1800.4,
    r: 3,
    fill: "#f4f4f4",
    className: "svgShape colorf4f4f4-27 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 1106.1,
    height: 21.3,
    x: 904.9,
    y: 1945.9,
    fill: "#efefef",
    className: "svgShape colorefefef-28 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 1106.1,
    height: 21.3,
    x: 904.9,
    y: 2025,
    fill: "#efefef",
    className: "svgShape colorefefef-29 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 1106.1,
    height: 21.3,
    x: 904.9,
    y: 2104,
    fill: "#efefef",
    className: "svgShape colorefefef-30 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 1106.1,
    height: 21.3,
    x: 904.9,
    y: 2183.1,
    fill: "#efefef",
    className: "svgShape colorefefef-31 selectable"
  }), /*#__PURE__*/React.createElement("rect", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 1106.1,
    height: 21.3,
    x: 904.9,
    y: 2262.1,
    fill: "#efefef",
    className: "svgShape colorefefef-32 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 1457.9,
    cy: 2399.5,
    r: 78.4,
    fill: "#bc4d1d",
    className: "svgShape color1dbc8e-33 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "1438 2438.3 1409.5 2409.8 1419 2400.3 1438 2419.4 1496.8 2360.6 1506.3 2370.1",
    fill: "#ffffff",
    className: "svgShape colorffffff-34 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1702,772.8L1702,772.8c-28,0-50.7-22.7-50.7-50.7l0,0c0-28,22.7-50.7,50.7-50.7l0,0     c28,0,50.7,22.7,50.7,50.7l0,0C1752.7,750.1,1730,772.8,1702,772.8z",
    fill: "#bc4d1d",
    className: "svgShape color1dbc8e-35 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M1691,714.1l0.7-0.7c3.2-3,3.4-7.9,0.5-11.2l-4-4.6c-1.8-2-4.9-2.1-6.8-0.2c-2.6,2.6-4.1,6.1-4.5,10.3     c-0.8,7.8,2.3,15.4,7.7,21c4.6,4.8,9.4,9.3,14.5,13.6c5.8,4.8,13.6,6.8,20.7,4.5c2-0.6,3.8-1.5,5.3-2.6c2.9-2.1,3.1-6.4,0.3-8.7     l-4.7-3.9c-2.2-1.8-5.4-1.8-7.6,0l-3.6,3c-1.3,1.1-3.2,0.9-4.3-0.3l-14.4-16.2C1689.7,717.2,1689.8,715.3,1691,714.1z",
    fill: "#ffffff",
    className: "svgShape colorffffff-36 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "2546.4 2695.1 2617.8 2696.9 2615.8 2590.9 2543.7 2590.9",
    fill: "#feab88",
    className: "svgShape colorfebd88-37 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2394.1,2747.6c38.7,24.3,111.9,19.2,197.3,18.8c13.4-0.1,27.1,0,41.1,0.3c3.8,0.1,7-2.7,7.5-6.4        c0.9-7.2,1.4-14.2,1.3-21.2c-0.2-16.5-3.3-32.5-10-47.9c-3.5-8.1-8-16-13.7-23.8c-25.4,16.2-49.4,16.5-72.1-10.6        c-6.9,2.4-13.6,5.7-20.2,9.3c-1.7,0.9-3.4,1.9-5,2.9c-3.2,1.9-6.5,3.9-9.8,5.8c-1.6,1-3.2,2-4.8,3c-2.8,1.7-5.6,3.4-8.5,5.2        l0,0c-1.6,1-3.2,1.9-4.9,2.9c-2.6,1.5-5.3,3-8,4.4c-1.7,0.9-3.4,1.8-5.2,2.7c-15.7,7.7-33.3,13.7-54.9,14.4        c-15.5,0.5-29.5,9.8-35,24.3c0,0.1-0.1,0.2-0.1,0.3v0.1C2386.7,2737.7,2388.9,2744.3,2394.1,2747.6z",
    fill: "#cc6133",
    className: "svgShape color33cc66-38 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2591.4,2766.4c13.4-0.1,27.1,0,41.1,0.3c3.8,0.1,7-2.7,7.5-6.4c0.9-7.2,1.4-14.2,1.3-21.2        c-0.2-16.5-3.3-32.5-10-47.9C2593.8,2709.8,2587.5,2725.7,2591.4,2766.4z",
    fill: "#bc4d1d",
    className: "svgShape color1dbc8e-39 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2394.1,2747.6c44.8,28.2,135.7,16.9,238.4,19.1c3.8,0.1,7-2.7,7.5-6.4c0.9-7.2,1.4-14.2,1.3-21.2        c-22.6,0.8-45,1-67.1,0.4c-13.9-0.3-27.8,0.8-41.4,3.9c-51.4,11.9-99.3,7.7-143.8-11.4v0.1        C2386.7,2737.7,2388.8,2744.3,2394.1,2747.6z",
    fill: "#b53e0b",
    className: "svgShape color0bb537-40 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2520.1 2668.9c4.7 3.4 9.4 8.3 12.7 14.8.4.9 1.4 1.5 2.4 1.5.4 0 .8-.1 1.2-.3 1.3-.7 1.8-2.3 1.2-3.6-3.3-6.6-7.8-11.6-12.4-15.3C2523.5 2667 2521.8 2667.9 2520.1 2668.9zM2505.6 2677.7c4.3 3.4 8.6 8 11.6 14 .5.9 1.4 1.5 2.4 1.5.4 0 .8-.1 1.2-.3 1.3-.7 1.9-2.3 1.2-3.6-3.1-6.2-7.3-10.9-11.6-14.6C2508.8 2675.7 2507.2 2676.7 2505.6 2677.7zM2492.2 2685.8c4.1 3.3 8.1 7.7 10.9 13.4.5.9 1.4 1.5 2.4 1.5.4 0 .8-.1 1.2-.3 1.3-.7 1.8-2.3 1.2-3.6-2.9-5.8-6.7-10.3-10.8-13.9l0 0C2495.5 2683.9 2493.8 2684.8 2492.2 2685.8zM2478.9 2692.9c4.3 3.4 8.7 8 11.7 14 .5.9 1.4 1.5 2.4 1.5.4 0 .8-.1 1.2-.3 1.3-.7 1.8-2.2 1.2-3.6-3-6-7.1-10.7-11.2-14.3C2482.4 2691.1 2480.7 2692 2478.9 2692.9z",
    fill: "#343333",
    className: "svgShape color343433-41 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "2771.5 2695.1 2843 2696.9 2841 2590.9 2768.9 2590.9",
    fill: "#feab88",
    className: "svgShape colorfebd88-42 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2619.2,2747.6c38.7,24.3,111.9,19.2,197.3,18.8c13.4-0.1,27.1,0,41.1,0.3c3.8,0.1,7-2.7,7.5-6.4        c0.9-7.2,1.4-14.2,1.3-21.2c-0.2-16.5-3.3-32.5-10-47.9c-3.5-8.1-8-16-13.7-23.8c-25.4,16.2-49.4,16.5-72.1-10.6        c-6.9,2.4-13.6,5.7-20.2,9.3c-1.7,0.9-3.4,1.9-5,2.9c-3.2,1.9-6.5,3.9-9.8,5.8c-1.6,1-3.2,2-4.8,3c-2.8,1.7-5.6,3.4-8.5,5.2        l0,0c-1.6,1-3.2,1.9-4.9,2.9c-2.6,1.5-5.3,3-8,4.4c-1.7,0.9-3.4,1.8-5.2,2.7c-15.7,7.7-33.3,13.7-54.9,14.4        c-15.5,0.5-29.5,9.8-35,24.3c0,0.1-0.1,0.2-0.1,0.3v0.1C2611.8,2737.7,2614,2744.3,2619.2,2747.6z",
    fill: "#cc6133",
    className: "svgShape color33cc66-43 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2816.5,2766.4c13.4-0.1,27.1,0,41.1,0.3c3.8,0.1,7-2.7,7.5-6.4c0.9-7.2,1.4-14.2,1.3-21.2        c-0.2-16.5-3.3-32.5-10-47.9C2819,2709.8,2812.6,2725.7,2816.5,2766.4z",
    fill: "#bc4d1d",
    className: "svgShape color1dbc8e-44 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2619.2,2747.6c44.8,28.2,135.7,16.9,238.4,19.1c3.8,0.1,7-2.7,7.5-6.4c0.9-7.2,1.4-14.2,1.3-21.2        c-22.6,0.8-45,1-67.1,0.4c-13.9-0.3-27.8,0.8-41.4,3.9c-51.4,11.9-99.3,7.7-143.8-11.4v0.1        C2611.8,2737.7,2614,2744.3,2619.2,2747.6z",
    fill: "#b53e0b",
    className: "svgShape color0bb537-45 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2745.3 2668.9c4.7 3.4 9.4 8.3 12.7 14.8.4.9 1.4 1.5 2.4 1.5.4 0 .8-.1 1.2-.3 1.3-.7 1.8-2.3 1.2-3.6-3.3-6.6-7.8-11.6-12.4-15.3C2748.6 2667 2747 2667.9 2745.3 2668.9zM2730.7 2677.7c4.3 3.4 8.6 8 11.6 14 .5.9 1.4 1.5 2.4 1.5.4 0 .8-.1 1.2-.3 1.3-.7 1.9-2.3 1.2-3.6-3.1-6.2-7.3-10.9-11.6-14.6C2733.9 2675.7 2732.4 2676.7 2730.7 2677.7zM2717.3 2685.8c4.1 3.3 8.1 7.7 10.9 13.4.5.9 1.4 1.5 2.4 1.5.4 0 .8-.1 1.2-.3 1.3-.7 1.8-2.3 1.2-3.6-2.9-5.8-6.7-10.3-10.8-13.9l0 0C2720.6 2683.9 2719 2684.8 2717.3 2685.8zM2704.1 2692.9c4.3 3.4 8.7 8 11.7 14 .5.9 1.4 1.5 2.4 1.5.4 0 .8-.1 1.2-.3 1.3-.7 1.8-2.2 1.2-3.6-3-6-7.1-10.7-11.2-14.3C2707.6 2691.1 2705.8 2692 2704.1 2692.9z",
    fill: "#343333",
    className: "svgShape color343433-46 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2512.2,1925.2l15.6,668.1l0.2,7.5l0.5,21.5c36.1,7.9,72.9,6.5,110,0c0.8-7.2,1.5-14.4,2.2-21.5     c0.3-2.5,0.5-5,0.7-7.5c11-114.8,15.1-227.4,13.4-338.2l16.6-367.2l83,712.8l2.5,21.5c35,7.4,69.3,7.1,102.9,0     c0.5-7.2,1-14.4,1.5-21.5c8.3-130.4,6.8-256.2-6.6-376.6l0.4-264.2c0.1-27.1,1.2-54.2,3-81.3c6.6-96.3-8.6-266.8-8.6-266.8     h-328.9C2511.7,1711.7,2509.4,1816.5,2512.2,1925.2z",
    fill: "#333333",
    className: "svgShape color333333-47 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m2528 2600.7.5 21.5c36.1 7.9 72.9 6.5 110 0 .8-7.2 1.5-14.4 2.2-21.5H2528zM2754.3 2600.7l2.5 21.5c35 7.4 69.3 7.1 102.9 0 .5-7.2 1-14.4 1.5-21.5H2754.3z",
    fill: "#282727",
    className: "svgShape color282827-48 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2194.5,1438.3c0.3-5.3,5-9.3,10.3-8.7c6.6,0.7,13.3,1.1,19.9,1.8c5.4,0.6,10.8,1.1,16.2,1.6      c5,0.5,10.3,1.5,15.3,0.9c7.3-0.9,13.6-5,20.1-8.1c0.2-0.1,0.4-0.2,0.7-0.3l33.8,70c-14.9,7.7-22.8,9.2-35.8,19.9l-13.6,11.1      c-16.6,16.1-43,16.1-59.7,0c-10.7-10.4-16.5-26.2-13.3-40.9c3.7-17.3,19.6-23.4,34.1-29.5c0.3-0.1,0.3-0.6,0-0.8      c-10.4-3.9-16.9-6.1-21.8-7.8C2196.8,1446.2,2194.3,1442.4,2194.5,1438.3z",
    fill: "#fba986",
    className: "svgShape colorfbbb86-49 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2305.6,1501.5c71.9-27.6,167.4-62.2,267.4-99c16.6-6.1,29.5-20.2,33.1-37.5c6.1-29.2,6.9-67.3-22.8-79.9      c-2-0.9-4-1.8-6-2.8c-2.3-1.2-4.8-2.4-7.4-3.6c0,0-157.1,63.1-303.2,146.7l2.6,5.1l35.4,69.2L2305.6,1501.5z",
    fill: "#cc6133",
    className: "svgShape color33cc66-50 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2901.3,1510.1L2901.3,1510.1l-22.4,5c-2.4-32.1-8.9-70.2-15.8-103.1c-9.7-39-4.8-20.7-14.6-59.3l1.5,62.7     l2.5,104.7l2.5,105.7c-144.4,3.9-267.2,3.2-347.2-6.2c2.7-85.5,9.9-211.1,18.3-347.8v-129.6c0-40.8,27.7-76.5,67.3-86.3     c0.2-0.1,0.5-0.1,0.7-0.2c10-2.4,19.7-4,30-5.2c22.3-2.6,44.8-3.1,67.3-2l111.5,5.5c11,0.5,21.9,2.1,32.5,5.1     c62.4,17.6,96.7,73.2,113.9,152c11,55.8,18.7,113.4,23.5,170.2C2981.5,1445.3,2957.5,1487.8,2901.3,1510.1z",
    fill: "#cc6133",
    className: "svgShape color33cc66-51 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2747.5,974.5v93.3c0,27.3-22.1,49.4-49.4,49.4l0,0c-27.3,0-49.4-22.1-49.4-49.4v-48.1L2747.5,974.5z",
    fill: "#faac8b",
    className: "svgShape colorfab68b-52 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2747.5,1000.7c-25.7,37.9-58.9,54.3-98.9,51.4v-32.4l98.9-45.1V1000.7z",
    fill: "#eb8a61",
    className: "svgShape coloreb8b61-53 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2815.5,891.2c10.1,47-17.8,67.9-52.9,61.2l-1.2,3.3c-13.1,35.1-42.1,62.2-78.3,72      c-5.5,1.5-11.1,2.6-16.6,3.4c-13.2,1.9-26.9,0-38.6-6.3c-32.5-17.5-54.9-59.7-56.2-152.8l-11.9-55.1l27.5-44.2l118.3-17.1      l85.4,59.7L2815.5,891.2z",
    fill: "#faab89",
    className: "svgShape colorfab589-54 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2804.1,905.4c2.3-0.5,4.8-0.9,7.5-1.2c-12.5-5.4-23.5-3.6-32.1,8.8c-2,2.9-1.4,6.8,1.4,8.9l0,0      c2.7,2,3.5,5.8,1.6,8.6c-2.7,4.1-7.4,7.6-12.6,11c13.6-0.8,24.4-6.4,31.7-17.9c1.6-2.5,1.3-5.7-0.7-7.8l0,0      C2797.7,912.4,2799.4,906.5,2804.1,905.4z",
    fill: "#ed8d64",
    className: "svgShape colored8f64-55 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2815.5,891.2c-22.3-18.8-39.9-2.2-56,26.2c2.7-38.6,6.2-77.8-10.7-100.5c-2.1-2.8-4.5-5.4-7.2-7.6      c-31,1.7-58.3-4.9-80.4-22.8c-20.1,3.8-41.2,4.5-63,2.3c-23.6,18.7-28.4,49-26.5,83.3c-12.8-18.5-22.2-38.5-25.7-57l0,0      c-5.4-28.4,3-53,34.3-62.6c9.5-58.1,55.6-66.4,122.5-46.4c30.5,15,61.8,19.7,93.9,15.8l-4.7,23.4c4.4,1.9,8.4,4.1,12,6.5      C2841.5,775.8,2843.6,823.3,2815.5,891.2z",
    fill: "#2b221e",
    className: "svgShape color2b231e-56 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2803.9,751.6c-14.2,28.3-32.8,49.7-55.1,65.3c-2.1-2.8-4.5-5.4-7.2-7.6c21.6-17.9,40.8-37.6,50.3-64.1      C2796.2,747.1,2800.2,749.2,2803.9,751.6z",
    fill: "#1d1613",
    className: "svgShape color1d1713-57 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2266.6,1425.4l4.2,8.2l0.2,0.7l31.4,60.8l3.2,6.2l141-52.6l-137.5,45.9l-33.6-66.6l128.6-75     C2359,1375.1,2313.2,1399,2266.6,1425.4z",
    fill: "#b53e0b",
    className: "svgShape color0bb537-58 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "2271.1 1434.4 2302.2 1495.2 2302.5 1495.2",
    fill: "#b53e0b",
    className: "svgShape color0bb537-59 selectable"
  }), /*#__PURE__*/React.createElement("line", {
    xmlns: "http://www.w3.org/2000/svg",
    x1: 2277.8,
    x2: 2278.5,
    y1: 1427.4,
    y2: 1428.9,
    fill: "none",
    className: "selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "2721.4 1514.5 2220.1 1514.6 2220.1 1502.5 2717.2 1502.5",
    fill: "#41342f",
    className: "svgShape color2f3c41-61 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "2609.6 1502.5 2220.1 1502.5 2163.8 1235.3 2545.9 1235.3",
    fill: "#50433e",
    className: "svgShape color3e4850-62 selectable"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    cx: 2367.4,
    cy: 1357.6,
    r: 23.4,
    fill: "#41342f",
    className: "svgShape color2f3c41-63 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2632.1,1436.3c2.2-4.9,8-6.9,12.7-4.5c5.9,3,12,5.8,18,8.8c4.8,2.4,9.7,4.9,14.5,7.3      c4.5,2.2,9.1,5.1,14,6.3c7.2,1.7,14.5,0.1,21.7-0.4c0.2,0,0.5,0,0.7,0l6.7,77.4c-16.7,1.9-24.6,0.5-40.6,5.8l-16.7,5.6      c-21.3,9.1-46-0.3-55.8-21.2c-6.3-13.5-6.1-30.3,2.1-43c9.6-14.9,26.7-14.9,42.4-15.4c0.4,0,0.5-0.5,0.3-0.7      c-8.3-7.3-13.7-11.7-17.6-15C2631.5,1444.5,2630.5,1440.1,2632.1,1436.3z",
    fill: "#fba986",
    className: "svgShape colorfbbb86-64 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M2694.8,1451l12.6,87.9c49-2.8,115.7-12.7,184.7-26.6c51-10.3,86.4-57,82.6-108.9      c-0.5-7.4-1.1-14.8-1.7-22.3l-17.8,4.9C2868.2,1413.9,2751.4,1441.6,2694.8,1451z",
    fill: "#cc6133",
    className: "svgShape color33cc66-65 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m2694.8 1451.2 12.7 87.7c39.6-2.2 90.9-9 145.5-18.9v-2.2l-140.7 14.4-10-75.2 153.4-42.1C2795.2 1430.7 2730.4 1445.2 2694.8 1451.2zM2848.9 1352.3c4.3 25.2 7.4 47.7 6.8 62.5l8-2C2863.7 1412.8 2849.7 1355.3 2848.9 1352.3z",
    fill: "#b53e0b",
    className: "svgShape color0bb537-66 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "489.9 2696.2 419.6 2698 421.6 2593.7 492.5 2593.7",
    fill: "#feab88",
    className: "svgShape colorfebd88-67 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M639.7,2747.9c-38.1,23.9-110.1,18.9-194.1,18.5c-13.2-0.1-26.7,0-40.4,0.3c-3.7,0.1-6.9-2.7-7.4-6.3       c-0.9-7-1.4-14-1.2-20.9c0.2-16.2,3.3-31.9,9.9-47.1c3.5-8,7.9-15.8,13.4-23.4c25,16,48.6,16.2,71-10.4       c6.8,2.4,13.4,5.6,19.9,9.2c1.7,0.9,3.3,1.8,4.9,2.8c3.2,1.8,6.4,3.8,9.6,5.7c1.6,1,3.1,2,4.7,2.9c2.7,1.7,5.5,3.4,8.4,5.1l0,0       c1.6,1,3.2,1.9,4.8,2.8c2.6,1.5,5.2,2.9,7.9,4.4c1.7,0.9,3.4,1.8,5.1,2.6c15.4,7.6,32.8,13.5,54,14.1       c15.2,0.5,29.1,9.7,34.4,23.9c0,0.1,0.1,0.2,0.1,0.3v0.1C647,2738.2,644.9,2744.6,639.7,2747.9z",
    fill: "#ff4d00",
    className: "svgShape colorff9900-68 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M445.6,2766.4c-13.2-0.1-26.7,0-40.4,0.3c-3.7,0.1-6.9-2.7-7.4-6.3c-0.9-7-1.4-14-1.2-20.9       c0.2-16.2,3.3-31.9,9.9-47.1C443.2,2710.7,449.4,2726.4,445.6,2766.4z",
    fill: "#ef5f22",
    className: "svgShape coloref5122-69 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M639.7,2747.9c-44.1,27.7-133.5,16.6-234.5,18.8c-3.7,0.1-6.9-2.7-7.4-6.3c-0.9-7-1.3-14-1.2-20.9       c22.3,0.8,44.3,1,66.1,0.4c13.7-0.3,27.4,0.8,40.7,3.8c50.6,11.7,97.7,7.6,141.5-11.2v0.1       C647,2738.2,644.9,2744.6,639.7,2747.9z",
    fill: "#e24603",
    className: "svgShape colore27703-70 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M515.7 2670.5c-4.6 3.4-9.3 8.1-12.5 14.6-.4.9-1.4 1.4-2.3 1.4-.4 0-.8-.1-1.2-.3-1.3-.6-1.8-2.2-1.2-3.5 3.2-6.4 7.7-11.4 12.2-15C512.4 2668.6 514 2669.5 515.7 2670.5zM530 2679.2c-4.2 3.3-8.5 7.8-11.4 13.7-.5.9-1.4 1.5-2.3 1.5-.4 0-.8-.1-1.2-.3-1.3-.6-1.8-2.2-1.2-3.5 3-6.1 7.1-10.8 11.4-14.4C526.9 2677.2 528.4 2678.2 530 2679.2zM543.2 2687.1c-4 3.2-8 7.6-10.7 13.2-.5.9-1.4 1.4-2.3 1.4-.4 0-.8-.1-1.2-.3-1.3-.6-1.8-2.2-1.2-3.5 2.8-5.7 6.6-10.2 10.6-13.7l0 0C540 2685.2 541.6 2686.1 543.2 2687.1zM556.3 2694.1c-4.3 3.3-8.5 7.8-11.5 13.8-.5.9-1.4 1.5-2.3 1.5-.4 0-.8-.1-1.2-.3-1.3-.6-1.8-2.2-1.2-3.5 2.9-5.9 6.9-10.5 11.1-14.1C552.8 2692.4 554.5 2693.2 556.3 2694.1z",
    fill: "#343333",
    className: "svgShape color343433-71 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "254.2 2696.2 183.9 2698 185.9 2593.7 256.8 2593.7",
    fill: "#feab88",
    className: "svgShape colorfebd88-72 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M404,2747.9c-38.1,23.9-110.1,18.9-194.1,18.5c-13.2-0.1-26.7,0-40.4,0.3c-3.7,0.1-6.9-2.7-7.4-6.3       c-0.9-7-1.4-14-1.2-20.9c0.2-16.2,3.3-31.9,9.9-47.1c3.5-8,7.9-15.8,13.4-23.4c25,16,48.6,16.2,71-10.4       c6.8,2.4,13.4,5.6,19.9,9.2c1.7,0.9,3.3,1.8,4.9,2.8c3.2,1.8,6.4,3.8,9.6,5.7c1.6,1,3.1,2,4.7,2.9c2.7,1.7,5.5,3.4,8.4,5.1l0,0       c1.6,1,3.2,1.9,4.8,2.8c2.6,1.5,5.2,2.9,7.9,4.4c1.7,0.9,3.4,1.8,5.1,2.6c15.4,7.6,32.8,13.5,54,14.1       c15.2,0.5,29.1,9.7,34.4,23.9c0,0.1,0.1,0.2,0.1,0.3v0.1C411.3,2738.2,409.2,2744.6,404,2747.9z",
    fill: "#ff4d00",
    className: "svgShape colorff9900-73 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M209.9,2766.4c-13.2-0.1-26.7,0-40.4,0.3c-3.7,0.1-6.9-2.7-7.4-6.3c-0.9-7-1.4-14-1.2-20.9       c0.2-16.2,3.3-31.9,9.9-47.1C207.5,2710.7,213.7,2726.4,209.9,2766.4z",
    fill: "#ef5f22",
    className: "svgShape coloref5122-74 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M404,2747.9c-44.1,27.7-133.5,16.6-234.5,18.8c-3.7,0.1-6.9-2.7-7.4-6.3c-0.9-7-1.3-14-1.2-20.9       c22.3,0.8,44.3,1,66.1,0.4c13.7-0.3,27.4,0.8,40.7,3.8c50.6,11.7,97.7,7.6,141.5-11.2v0.1       C411.3,2738.2,409.2,2744.6,404,2747.9z",
    fill: "#e24603",
    className: "svgShape colore27703-75 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M280 2670.5c-4.6 3.4-9.3 8.1-12.5 14.6-.4.9-1.4 1.4-2.3 1.4-.4 0-.8-.1-1.2-.3-1.3-.6-1.8-2.2-1.2-3.5 3.2-6.4 7.7-11.4 12.2-15C276.7 2668.6 278.4 2669.5 280 2670.5zM294.3 2679.2c-4.2 3.3-8.5 7.8-11.4 13.7-.5.9-1.4 1.5-2.3 1.5-.4 0-.8-.1-1.2-.3-1.3-.6-1.8-2.2-1.2-3.5 3-6.1 7.1-10.8 11.4-14.4C291.2 2677.2 292.7 2678.2 294.3 2679.2zM307.5 2687.1c-4 3.2-8 7.6-10.7 13.2-.5.9-1.4 1.4-2.3 1.4-.4 0-.8-.1-1.2-.3-1.3-.6-1.8-2.2-1.2-3.5 2.8-5.7 6.6-10.2 10.6-13.7l0 0C304.3 2685.2 305.9 2686.1 307.5 2687.1zM320.6 2694.1c-4.3 3.3-8.5 7.8-11.5 13.8-.5.9-1.4 1.5-2.3 1.5-.4 0-.8-.1-1.2-.3-1.3-.6-1.8-2.2-1.2-3.5 2.9-5.9 6.9-10.5 11.1-14.1C317.1 2692.4 318.8 2693.2 320.6 2694.1z",
    fill: "#343333",
    className: "svgShape color343433-76 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M530,1902l-16.4,702.8l-0.2,7.9l-0.5,22.7c-38,8.3-76.6,6.9-115.7,0c-0.8-7.6-1.6-15.1-2.3-22.7      c-0.3-2.6-0.5-5.2-0.8-7.9C382.5,2484,378.2,2365.6,380,2249l-17.4-386.2l-87.4,749.9l-2.6,22.7c-36.8,7.8-72.9,7.4-108.3,0      c-0.5-7.6-1-15.1-1.5-22.7c-8.8-137.2-7.2-269.5,7-396.2l-0.5-277.9c-0.1-28.5-1.3-57-3.2-85.5c-7-101.3,9.1-280.7,9.1-280.7      h346C530.5,1677.5,533,1787.7,530,1902z",
    fill: "#333333",
    className: "svgShape color333333-77 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m513.4 2612.7-.5 22.7c-38 8.3-76.6 6.9-115.7 0-.8-7.6-1.6-15.1-2.3-22.7H513.4zM275.2 2612.7l-2.6 22.7c-36.8 7.8-72.9 7.4-108.3 0-.5-7.6-1-15.1-1.5-22.7H275.2z",
    fill: "#282727",
    className: "svgShape color282827-78 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M404.2,739.1c-91.1-104.9-269.9-5.8-272.7,167.8c-0.1,4.9-0.1,9.8-0.5,14.8c-0.5,7.1-1.2,14.2-2.2,21.1     c-5.4,40.8-20.9,79.4-43.3,114c-56.4,87.4-12.8,162.9,67.6,197.9l312.2-66.5c70.5-24.4,117.8-59.1,42.7-148     c-14.2-16.8-27-34.9-36.8-54.7c-20.5-41.3-28-83.2-21.3-125.6C500.6,826.5,486,760.8,404.2,739.1z",
    fill: "#2b221e",
    className: "svgShape color2b231e-79 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M535.4,1640.9c0.4,27.4-52.2,42.7-118.7,47.3c-38.6,2.7-81.9,1.7-122.3-2.6c-60.6-6.5-114.5-20.5-135.7-41.2     c-5.7-5.6-8-13.9-6.5-21.8c41.1-154.7,28.5-229.6-1.6-349.5l61.1-200.7c71.8-7.4,97.4-9.3,187.5-7c13.5,0.4,26.9,2,40,5.5     c20.1,5.3,39.7,14.7,58.7,31.1l11.5,44.3c6.8,67,3.1,165.7-9.4,253.4c-4.2,29.6-2.8,59.8,4.7,88.7     C518,1540.3,534.9,1605,535.4,1640.9z",
    fill: "#ff4d00",
    className: "svgShape colorff9900-80 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M274.1,1084.5c-0.6-2.4-1-4.9-1.2-7.4C273.2,1079.5,273.7,1082,274.1,1084.5z",
    fill: "#feab88",
    className: "svgShape colorfebd88-81 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M377.8,795.4c11.1,33.3,26.2,53.9,43.6,67.1c3.7,226.4-158,189.6-208.8,102.4c-25.4,1.3-49.8-16.3-53.2-45       c-0.7-5.7,0.8-11.7,4.9-15.7c16.5-16.3,41.9,24.6,41.9,24.6l2.9-53.4C286.4,863.4,349.6,841.5,377.8,795.4z",
    fill: "#faab89",
    className: "svgShape colorfab589-82 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M419.6 887.6c42.6 9.3 21.7 64-11.1 68.8L419.6 887.6zM363.1 1008.9v64.2c0 1.3-.1 2.6-.2 3.8-1.9 23.2-21.3 41.4-45 41.4-21.1 0-38.8-14.4-43.8-33.9l0 0c-.4-2.5-.8-5-1.2-7.4 0 0 0 0 0-.1-.1-1.2-.2-2.5-.2-3.8v-64.2L363.1 1008.9 363.1 1008.9z",
    fill: "#faab89",
    className: "svgShape colorfab589-83 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "26 1500.4 25.2 1501.1 25.2 1500.4",
    fill: "#f1713a",
    className: "svgShape colorf1673a-84 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "26 1500.4 25.2 1501.1 25.2 1500.4",
    fill: "#f1713a",
    className: "svgShape colorf1673a-85 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M318.5,1612.8c0.6-5.2-3.5-9.7-8.9-9.9c-6.8-0.2-13.5-0.7-20.3-1c-5.5-0.2-11-0.4-16.5-0.6      c-5.1-0.2-10.6,0.1-15.5-1.2c-7.2-1.9-12.8-6.7-18.9-10.6c-0.2-0.1-0.4-0.3-0.6-0.4l-45,63.2c13.8,9.5,21.4,12.1,32.8,24.2      l11.9,12.6c14.1,17.9,40.6,21.5,59.9,8.2c12.4-8.6,20.7-23.1,19.9-37.9c-0.9-17.3-16-25.4-29.6-33.3c-0.3-0.2-0.2-0.7,0.1-0.7      c11-2.3,17.9-3.6,23.1-4.6C315,1620.1,318.1,1616.8,318.5,1612.8z",
    fill: "#fba986",
    className: "svgShape colorfbbb86-86 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M244.9,1589.8l-42.8,73.5c-44.8-29.6-96.4-63-147.7-99.4v-0.2c-18.4-11-31.1-42.8-29.1-62.5l0.7-0.7h-0.7     c7.5-192.8,39.4-397.5,186.6-428.2l-6,202c-38.9,53.6-56,110.3-72.5,214.7c-0.2,1.5-0.5,2.7-0.7,4.2c0.5,0.2,1,0.7,1.5,1.2     C165.2,1521.8,201.8,1552.9,244.9,1589.8z",
    fill: "#ff4d00",
    className: "svgShape colorff9900-87 selectable"
  }), /*#__PURE__*/React.createElement("polygon", {
    xmlns: "http://www.w3.org/2000/svg",
    points: "244.9 1589.8 241.2 1596.3 204.8 1658.3 202.1 1663.3 193.8 1657.8 112.1 1603.8 196.6 1653.6 235.4 1590.6 179.6 1534 239.2 1584.8",
    fill: "#e24603",
    className: "svgShape colore27703-88 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M670.8,1016.6c-4.7,0.8-7.7,5.6-6.4,10.4c1.6,6,2.8,12.1,4.3,18.2c1.2,4.9,2.5,9.8,3.7,14.8      c1.1,4.5,2.8,9.3,2.9,14c0.2,6.9-2.7,13.1-4.5,19.5c-0.1,0.2-0.1,0.4-0.2,0.6l67.5,23.5c4.9-14.6,5.2-22.1,12.9-35.2l8.1-13.7      c12.2-17.1,8.6-41.5-8.2-55.1c-10.8-8.7-25.8-12.3-38.6-7.8c-15.1,5.3-18.4,20.7-21.8,34.7c-0.1,0.3-0.5,0.4-0.7,0.1      c-4.9-9.1-7.8-15-10-19.2C678.2,1017.9,674.5,1016,670.8,1016.6z",
    fill: "#fba986",
    className: "svgShape colorfbbb86-89 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M743.8,1109.2c-29.1,123.5-63.3,198.1-98.1,266.6c-10.2,20.1-34.1,29.7-55.3,21.8      c-37.7-13.9-81.6-48.8-107.5-105.8l-6.8-205.5c36.4,19.2,74.9,75,117.6,159.5c0.9,1.7,3.4,1.6,4.1-0.2l72.9-160.2L743.8,1109.2z      ",
    fill: "#ff4d00",
    className: "svgShape colorff9900-90 selectable"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M743.8,1109.3c-0.7,3-1.5,6-2.2,8.7c-5.5,22.9-11,43.6-15.9,60.8l9.7-63.3l-61.8-22.2l-28.1,47.6l22.7-49.6     l2.7-6l43.1,14.2l22.7,7.2L743.8,1109.3z",
    fill: "#e24603",
    className: "svgShape colore27703-91 selectable"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpBlack);
export default __webpack_public_path__ + "static/media/expBlack.762d013469eedde52696294367e0159c.svg";
export { ForwardRef as ReactComponent };